import { omit } from 'lodash';
import { PageRecipientBasicModel } from '@/helpers/entities/models/PageRecipientBasicModel';
import { InquiryProductBasicModel } from '@/helpers/entities/models/InquiryProductBasicModel';
import { UserModel } from '@/helpers/entities/models/UserModel';
import { standardDate } from '@/helpers/DateFormatter';
import { InquiryCustomAnswerModel } from './InquiryCustomAnswerModel';
export class InquiryRequestFullModel {
    /**
     * Inquiry Request Full Model
     * ORM for Inquiry List and Data Export
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.0.20}
     */
    constructor(payload) {
        this.productName$ = null;
        this.assigneeName$ = null;
        const { pageRecipient, inquiryProduct, assignee } = payload;
        const params = omit(payload, 'pageRecipient', 'inquiryProduct', 'assignee', 'customAnswers');
        Object.assign(this, params);
        this.pageRecipient = new PageRecipientBasicModel(pageRecipient);
        this.pageRecipientName$ = this.pageRecipient.name;
        this.pageRecipientProfilePic$ = this.pageRecipient.profilePic;
        if (inquiryProduct) {
            this.inquiryProduct = new InquiryProductBasicModel(inquiryProduct);
            this.productName$ = this.inquiryProduct.name;
        }
        if (assignee) {
            this.assignee = new UserModel(assignee);
            this.assigneeName$ = this.assignee.fullName;
        }
        this.inquiryDate$ = this.inquiryDate;
        const customAnswers = payload.customAnswers.edges;
        if (customAnswers) {
            this.customAnswers = customAnswers.map((answer) => {
                return new InquiryCustomAnswerModel(answer.node);
            });
        }
    }
    get inquiryDate() {
        return standardDate(this.createdAt);
    }
    get fullAddress() {
        const { city, region, country } = this;
        return `${city} ${region}, ${country}`;
    }
    get contactDetails() {
        const { mobileDialCode, mobileNumber } = this;
        return `${mobileDialCode}${mobileNumber}`;
    }
    get fullName() {
        const { firstName, lastName } = this;
        return `${firstName} ${lastName}`;
    }
}
